import { MessageCircle } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Accordion } from '@/components/ui/accordion'
import { FaqItem } from './FaqItem'
import { useTranslation } from '@/hooks/useTranslation'

export function Faq() {
	const { t, i18n } = useTranslation()
	const isFrench = i18n.language?.startsWith('fr')
	const description = isFrench
		? 'Des réponses pratiques sur l’installation, l’offre gratuite, la personnalisation et l’utilisation sur mobile.'
		: 'Practical answers about installation, the free plan, customization, and using Feedbask on mobile.'
	const installationAnswer = isFrench
		? 'Ajoutez le code d’intégration Feedbask à votre site, puis configurez le widget depuis votre tableau de bord. Le temps exact dépend de votre stack et de votre processus de déploiement.'
		: 'Add the Feedbask embed code to your site, then configure the widget from your dashboard. The exact time depends on your stack and deployment workflow.'
	const freePlanAnswer = isFrench
		? 'Oui. L’offre gratuite inclut 1 projet, 10 réponses par mois, 5 bugs par mois, 5 demandes de fonctionnalités par mois, une roadmap publique, 3 jours d’historique de chat et la marque Feedbask.'
		: 'Yes. The Free plan includes 1 project, 10 responses per month, 5 bug reports per month, 5 feature requests per month, a public roadmap, 3 days of live chat history, and Feedbask branding.'

	return (
		<section className="py-20 sm:py-24 lg:py-28" id="faq">
				<div className="container mx-auto grid gap-12 lg:grid-cols-[.72fr_1.28fr] lg:gap-20">
				<div className="flex flex-col items-start">
					<div className="flex flex-col gap-2">
						<span className="text-xs font-semibold uppercase tracking-[.2em] text-[#6547D9]">{t('faq.label')}</span>
						<h2 className="mt-2 max-w-sm font-heading text-4xl font-semibold tracking-[-.04em] text-[#17131F] sm:text-5xl">
							{t('faq.title')}
						</h2>
					</div>
					<p className="mt-5 max-w-md text-base leading-7 text-slate-600 sm:text-lg">{description}</p>
					<Button
						asChild
						className="mt-7 gap-2 bg-[#6547D9] font-semibold text-white hover:bg-[#5638C7]"
					>
						<a href="mailto:contact@feedbask.com">
							<MessageCircle size={16} />
							{t('faq.contactUs')}
						</a>
					</Button>
				</div>
				<Accordion type="single" collapsible className="w-full border-t border-[#DDD8E8]">
					<FaqItem question={t('faq.questions.installationTime.question')} answer={installationAnswer} />
					<FaqItem question={t('faq.questions.freePlan.question')} answer={freePlanAnswer} />
					<FaqItem question={t('faq.questions.customization.question')} answer={t('faq.questions.customization.answer')} />
					<FaqItem question={t('faq.questions.mobile.question')} answer={t('faq.questions.mobile.answer')} />
					<FaqItem question={t('faq.questions.settings.question')} answer={t('faq.questions.settings.answer')} />
				</Accordion>
			</div>
		</section>
	)
}
